import React from 'react';

interface SvgArrowProps {
  color?: string;
  width?: number;
  height?: number;
  direction?: 'up' | 'down' | 'left' | 'right';
}

const SvgArrow: React.FC<SvgArrowProps> = ({ 
  color = '#292D32',
  width = 24,
  height = 24,
  direction = 'left' // Default to left (original orientation)
}) => {
  // Calculate rotation based on direction
  const getRotation = () => {
    switch (direction) {
      case 'up':
        return 'rotate(90deg)';
      case 'down':
        return 'rotate(-90deg)';
      case 'right':
        return 'rotate(180deg)';
      case 'left':
      default:
        return 'rotate(0deg)';
    }
  };

  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 639 472" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{
        transform: getRotation(),
        transformOrigin: 'center'
      }}
    >
      <path 
        d="M235.598 26L26 235.597L235.598 445.195" 
        stroke={color} 
        strokeWidth="51.7952" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
      <path 
        d="M613.077 235.609H31.9355" 
        stroke={color} 
        strokeWidth="51.7952" 
        strokeMiterlimit="10" 
        strokeLinecap="round" 
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SvgArrow; 